import React, {useEffect, useRef, useState} from 'react';
import {useLocation} from "react-router-dom";
import FromFieldText from '../../atoms/FromFieldText';
import FromFieldSelect from '../../atoms/FromFieldSelect';
import {getOtherTagDivisionsInfo, saveOtherTagDivision} from '../../services/master.service';

import * as CryptoJS from "crypto-js";
import {getCompanyProfileList} from "../../services/user.service";

const TEXT_REGEX = /^[a-zA-Z0-9-_ ]{1,255}$/;
//const Email_REGEX = /^[a-zA-Z0-9@.-_ ]{1,255}$/;
//const Mobile_REGEX = /^[0-9]{10,10}$/;

function AddOtherTagDivision() {

    //const [categoryInfo, setCategoryInfo] = useState({});
    //const [validName, setValidName] = useState(true);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [companyId, setCompanyId] = useState('');
    const [ErrCompanyId, setErrCompanyId] = useState(false);

    const [tagdivision, setTagDivision] = useState('');
    const [ErrTagDivision, setErrTagDivision] = useState(false);

    const [tagdivisionshortname, setTagDivisionShortName] = useState('');
    const [ErrTagDivisionShortName, setErrTagDivisionShortName] = useState(false);

    const [PurposeOfFlaging, setPurposeOfFlaging] = useState('');
    const [ErrPurposeOfFlaging, setErrPurposeOfFlaging] = useState(false);

    const [companies, setCompanies] = useState([]);
    const [grouping, setGrouping] = useState(["Internal Repair","External Repair","Disposable"]);
    const resetUserInfo = function () {
        setTagDivision('');
        setTagDivisionShortName('');
        setCompanyId('');setPurposeOfFlaging('');
    }

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const tagdivid = query.get('tagdivid');
    const elementRef = useRef();
    useEffect(() => {

        if (tagdivid != '' && tagdivid != null) {

            // Rename the Roleid from the decrypt_data
            const decryptedBytes = CryptoJS.AES.decrypt(tagdivid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            // Convert the decrypted bytes to a string
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            //console.log(decrypt_data);
            const decryptedRoleid = decrypt_data.tagdiv_id;
            // Use decryptedRoleid in the getRoleInfoData function
            //getRoleInfoData(decryptedRoleid);
            getTagDivisionInfo(decryptedRoleid);
            //alert(Tag);
        }

        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            //'param_data':obj,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = {'token': EncryptData}
            getCompanyProfileList(oData).then(res => {
            if (res?.data?.data?.length) setCompanies(res.data.data);
        });
    }, [])

    const getTagDivisionInfo = function (tagdivid) {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': {'tagdivid': tagdivid},
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();

        let oData1 = {'token': EncryptData};

        getOtherTagDivisionsInfo(oData1).then(function (res) {
            //console.log(res.data.data);
            if (res?.data?.data && res.data.data.length > 0) {
                var tagInfo = res.data.data[0];
                // Check if the 'company_id' property exists before setting the state
                if ('company_id' in tagInfo) {
                    setCompanyId(tagInfo.company_id);
                }
                // Check if the 'tag_division_name' property exists before setting the state
                if ('tag_division_name' in tagInfo) {
                    setTagDivision(tagInfo.tag_division_name);
                }
                if ('tag_division_short_name' in tagInfo) {
                    setTagDivisionShortName(tagInfo.tag_division_short_name);
                }
                if ('purpose_of_flaging' in tagInfo) {
                    setPurposeOfFlaging(tagInfo.purpose_of_flaging);
                }
            } else {
                // Handle the case where the API response does not contain the expected data
                console.error("Invalid API response format");
            }
        }).catch(function (error) {
            // Handle API request errors here
            console.error("Error fetching data from API: ", error);
        });
    };

    const handleCompanyId = (e) => {
        setCompanyId(e.target.value);
    }
    const handleGrouping = (e) => {
        setPurposeOfFlaging(e.target.value);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;
        // if button enabled with JS hack
        //const v1 = TEXT_REGEX.test(name);
        if (!TEXT_REGEX.test(companyId)) { //alert(name);
            setErrCompanyId('Company name is required');
            valid_Name = false; //alert(valid_Name);
            //return;
        } else {
            setErrCompanyId('');
        }
        if (!TEXT_REGEX.test(tagdivision)) { //alert(name);
            setErrTagDivision('TAG division name is required');
            valid_Name = false; //alert(valid_Name);
            //return;
        } else {
            setErrTagDivision('');
        }
        if (!TEXT_REGEX.test(tagdivisionshortname)) { //alert(name);
            setErrTagDivisionShortName('TAG division short name is required');
            valid_Name = false; //alert(valid_Name);
            //return;
        } else {
            setErrTagDivisionShortName('');
        }
        if (!TEXT_REGEX.test(PurposeOfFlaging)) { //alert(name);
            setErrPurposeOfFlaging('Other Purpose of flaging is required');
            valid_Name = false; //alert(valid_Name);
            //return;
        } else {
            setErrPurposeOfFlaging('');
        }
        if (valid_Name) { //alert('test1');
            saveData(); //submit form
        } else {  //alert('fa');
            return false;
        }
    }

    const saveData = function () {
        try {

            if (tagdivid !== '' && tagdivid !== null) {
                const decryptedBytes = CryptoJS.AES.decrypt(tagdivid.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
                // Convert the decrypted bytes to a string
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                const decryptedTagDivID = decrypt_data.tagdiv_id;
                var obj = {
                    'tag_divs_id': decryptedTagDivID,
                    'tag_division_name': tagdivision,
                    'tag_division_short_name': tagdivisionshortname,
                    'purpose_of_flaging': PurposeOfFlaging,
                    'company_id': companyId,
                    'status': '1',
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                }
            } else {
                var obj = {
                    'tag_division_name': tagdivision,
                    'tag_division_short_name': tagdivisionshortname,
                    'purpose_of_flaging': PurposeOfFlaging,
                    'company_id': companyId,
                    'status': '1',
                    'created_by': sessionStorage.getItem('LoggedInUserId'),
                }
            }

            //encrypted data
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': obj,
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = {'token': EncryptData}

            saveOtherTagDivision(oData).then(function (res) {
                ////console.log(res);
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetUserInfo();
                }
            });

            //setValidName(false);
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                //console.log(err);
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('data already exist');
            } else {
                setErrMsg('Insert/Update Failed');
            }
            //elementRef.current.focus();
        }
    }

    return (
        <div className="container">

            <div className="row">
                <div className="col-6">
                    <h5>Add Other Purpose</h5>
                </div>
                <div className="invalid-feedback" role="alert">
                    <i className="fa fa-info-circle"></i>
                    Please Fill all mandatory field.
                </div>

                {success ? (
                    <div className="alert alert-success" role="alert"><i
                        className="bi bi-check-circle-fill"></i>{success}</div>
                ) : (errMsg ? (<div className="alert alert-danger" role="alert"><i
                        className="bi bi-exclamation-triangle-fill"></i>{errMsg}</div>) : ('')
                )}
            </div>

            <div className='row '>
                <div className='col-12'>&nbsp;</div>

            </div>
            <form onSubmit={handleSubmit}>
                <div className="row form-fields">
                    <div className="label col-3">
                        <label>Company </label><span className="star error"> *</span>
                    </div>

                    <div className="item col-3">
                        <select className="form-select form-select-sm mb-3" onChange={handleCompanyId}>
                            <option value="">Select Company</option>
                            {companies && companies.length > 0 ? (
                                companies.map((option) => (
                                    <option value={option.company_id}
                                            selected={(option.company_id == companyId) ? "selected" : ''}>{option.company_name}</option>
                                ))
                            ) : (
                                <option value="">No Data</option>
                            )}
                        </select>
                        <span className="invalid-feedback"> {ErrCompanyId} </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <FromFieldText star="*"
                            label="Other Purpose Name"
                            inputValue={tagdivision}
                            setInputValue={setTagDivision}
                            setErrorMsg={ErrTagDivision}
                        />
                    </div>
                    <div className="col-6"></div>

                </div>

                <div className="row">
                    <div className="col-6">
                        <FromFieldText star="*"
                            label="Other Purpose Short Name"
                            inputValue={tagdivisionshortname}
                            setInputValue={setTagDivisionShortName}
                            setErrorMsg={ErrTagDivisionShortName}
                        />
                    </div>
                    <div className="col-6"></div>

                </div>
                <div className="row form-fields">
                    <div className="label col-3">
                        <label>Other Purpose of Grouping </label><span className="star error"> * </span>
                    </div>
                    <div className="item col-3">
                        <select className="form-select form-select-sm mb-3" onChange={handleGrouping}>
                            <option value="">Select Other Purpose of Grouping</option>
                            {grouping && grouping.length > 0 ? (
                                grouping.map((val) => (
                                    <option value={val} selected={(val == PurposeOfFlaging) ? "selected" : ''}>{val}</option>
                                ))
                            ) : (
                                <option value="">No Data</option>
                            )}
                        </select>
                        <span className="invalid-feedback"> {ErrPurposeOfFlaging} </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-3"></div>
                    <div className="col-6">
                        <button className="btn btn-primary  btn-sm"> SAVE</button>
                    </div>
                    <div className="col-3"></div>
                </div>
            </form>
        </div>
    )
}

export default AddOtherTagDivision


